"use strict";

exports.__esModule = true;
exports.default = isHexColorValue;

function isHexColorValue(value) {
  return /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(value);
}